import { render } from "./TableView.vue?vue&type=template&id=1bff49fa&scoped=true"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=1bff49fa&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_@vue+compiler-sfc@3.3.11_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bff49fa"]])

export default __exports__